import React, { useEffect, useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { LenderMappingsFormValues } from 'modules/vendorOpportunity/dynamicLenderSubmissionMappings/types';
import { DateField } from 'components/form';
import { LenderFieldMap } from '@trnsact/trnsact-shared-types';
import { DateFormats } from 'constants/common';

interface Props {
  field: LenderFieldMap;
  onValueChange: (lenderProperty: string, newValue: any) => void;
}

export const DateMappingField = ({ field, onValueChange }: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<LenderMappingsFormValues>();

  const currentValue = useWatch({
    control,
    name: `mappingsByLenderFieldId.${field.lenderFieldId}.mappedValue`,
  });

  const prevValueRef = useRef(currentValue);

  useEffect(() => {
    if (prevValueRef.current !== currentValue && field.lenderProperty) {
      prevValueRef.current = currentValue;
      onValueChange(field.lenderProperty, currentValue);
    }
  }, [currentValue, field.lenderProperty, onValueChange]);

  return (
    <DateField
      label={field.details?.displayName!}
      control={control}
      name={`mappingsByLenderFieldId.${field.lenderFieldId}.mappedValue`}
      format={DateFormats.Short}
      slotProps={{
        textField: {
          variant: 'outlined',
          size: 'small',
          required: field.details?.required === 'REQUIRED',
          error: !!errors?.mappingsByLenderFieldId?.[field.lenderFieldId!]?.mappedValue,
        },
      }}
    />
  );
};
